{
  "base_password": "Password",
  "base_loading": "Loading...",
  "base_item": "Item",
  "base_date": "Date",
  "base_hour": "Hour",
  "base_description": "Description",
  "base_value": "Value",
  "base_add": "Add",
  "base_submit": "Submit",
  "base_product": "Product",
  "base_confirm": "Confirm",
  "base_quantity": "Qty",
  "base_cancel": "Cancel",
  "base_select": "Select",
  "base_code": "Code",

  "account_myPurchases": "My Purchases",
  "account_view": "View",
  "account_emptyNotice": "No purchase found.",
  "account_previous": "Previous",
  "account_next": "Next",
  "account_itemsQuantity": "{quantity} item(s)",
  "account_sellNumber": "Order #{orderCode}",
  "account_log_out_button": "Log out",
  "account_total_purchases": "Total",
  "account_sale_item_without_date": "No Scheduling",
  "account_sale_total_value": "Total value",
  "account_sale_discount": "Discount",
  "account_sale_date": "Date and time",
  "account_sale_reschedule": "Reschedule",
  "account_sale_reservation_tariff": "Tariffs",
  "account_sale_reservation_voucher": "Actions",
  "account_sale_reservation_places": "Places",
  "account_sale_checkout": "Checkout",
  "account_sale_download_all": "Download All",
  "account_sale_reschedule_disabled": "It is not possible to reschedule promotional reservations. Contact the establishment for more information",
  "account_sale_reschedule_success_message": "Reschedule successfully confirmed",
  "account_sale_voucher_revoketed": "Canceled",
  "account_empty_state": "You still don't have any purchases",
  "account_sale_package_title": "{packageName} with {quantity} activities",
  "account_sale_reschedule_tooltip": "Promotional reservations cannot be rescheduled. Contact the property for more information.",
  "account_sale_voucher_pending": "Pending Voucher",
  "account_sale_pending_voucher_info": "Your purchase payment has been confirmed. <strong>The voucher is being generated</strong> with the partner and will be available soon.",
  "account_sale_download_all_vouchers_tooltip": "Voucher pending, wait for confirmation",
  "account_sale_voucher_pending_status": "Waiting for confirmation",
  "account_sale_change_amount": "Reschedule addition",
  "account_sale_original_total_value": "Original purchase total value",
  "account_email_change_title": "E-mail change confirmation",
  "account_email_change_confirm_title": "Your registration data has been updated.",
  "account_email_change_description": "To continue, enter your current e-mail. We will validate the code sent to the new address.",
  "account_email_change_confirm_description": "<strong><em>{app}</em></strong> updated your registration data.<br></br>Do you agree that your data can be updated in our database?",
  "account_email_change_current_email_label": "Current e-mail",
  "account_email_change_new_email_label": "New e-mail",
  "account_email_change_login_button": "Continue",
  "account_email_change_confirm_button": "I agree",
  "account_email_change_decline_button": "I do not agree",
  "account_email_change_success": "Email change confirmed successfully.",
  "account_email_change_declined": "The email change was declined.",
  "account_email_change_invalid_link": "This confirmation link is invalid or incomplete.",
  "account_email_change_error": "We could not complete the e-mail change. Try again or request a new link.",

  "reservation_download": "Download",
  "reservation_rescheduling": "Rescheduling...",
  "voucher_download": "Download",

  "reschedule_step_date": "Select a date",
  "reschedule_step_time": "Select a time",
  "reschedule_step_summary": "Confirm selection",
  "reschedule_go_back_button": "Go back",
  "reschedule_confirm_button": "Confirm",
  "reschedule_make_payment_button": "Make payment",
  "reschedule_go_forward_button": "Continue",
  "reschedule_selected_date": "Selected Date",
  "reschedule_selected_time": "Selected time",
  "reschedule_error_reschedulingLimitExceeded": "Rescheduling limit exceeded",
  "reschedule_error_reschedulingToHigherTariffNotAllowed": "It is not possible to reschedule to a higher tariff",
  "reschedule_error_reschedulingToLowerTariffNotAllowed": "It is not possible to reschedule to a lower tariff",
  "reschedule_error_reschedulingAntecedenceNotMet": "The rescheduling advance must be at least {minAntecedence}",
  "reschedule_error_scheduleTimeMustDifferFromCurrent": "The selected time must differ from the current time",
  "reschedule_error_schedulingIsValid": "The selected date is not valid",
  "reschedule_error_invalidValue": "The selected date is not valid",
  "reschedule_days": "{count, plural, one {{count, number} day} other {{count, number} days}}",
  "reschedule_hours": "{count, plural, one {{count, number} hour} other {{count, number} hours}}",
  "reschedule_minutes": "{count, plural, one {{count, number} minute} other {{count, number} minutes}}",
  "reschedule_charge_summary_alert_title": "Ensure that the new date is correct",
  "reschedule_charge_summary_alert_description": "Your current reservation is scheduled for {date}. After confirming, your ticket will no longer have access to that date and you will have {remainingRescheduleCount} reschedule remaining.",
  "reschedule_charge_summary_actual_schedule": "Current reservation",
  "reschedule_charge_summary_new_schedule": "New reservation",
  "reschedule_charge_summary_total_to_pay": "Total to pay",
  "reschedule_charge_summary_disclaimer": "Your reservation for {date} is guaranteed until the rescheduling is confirmed.",
  "reschedule_charge_summary_pay_button": "Make payment",
  "reschedule_info_remaining_reschedule_count": "Available reschedules: ",
  "reschedule_info_reschedule_until_title": "Reschedule request deadline: ",
  "reschedule_history_old_reservation_value": "Old reservation: ",
  "reschedule_history_new_reservation_value": "New reservation: ",
  "reschedule_applied_message": "Reschedule confirmed",
  "reschedule_expired_message": "The payment to finalize the reschedule has expired",
  "reschedule_pending_payment_message": "Make the payment for the reschedule to the date {date} be confirmed.",
  "reschedule_pending_payment_message_title": "Reschedule Pending",
  "reschedule_info_reschedule_until_expired": "The reschedule request deadline has expired",
  "reschedule_error_saleItemHasPayableSaleChanges": "The reservation has a pending reschedule payment",

  "auth_processing": "Processing...",
  "auth_checkoutHeaderTitle": "I already have an Account",
  "auth_accountHeaderTitle": "Login",
  "auth_alreadyHaveAnAccount": "I already have an account",
  "auth_wantToSignup": "I want to Sign Up",
  "auth_signupPasswordInfo": "It must contain at least 8 characters, with at least one uppercase letter, one lowercase letter and one number.",
  "auth_inputEmail": "Type your e-mail",
  "auth_inputPassword": "Password",
  "auth_labelPassword": "Password",
  "auth_labelEmail": "E-mail",
  "auth_forgotPassword": "Forgot my password",
  "auth_login": "Login",
  "auth_submit": "Submit",
  "auth_registerMessage": "Don't have an account? Register",
  "auth_createAccount": "Create Account",
  "auth_labelName": "Name",
  "auth_labelSurname": "Surname",
  "auth_mailConfirmation": "Confirm E-mail",
  "auth_passwordConfirmation": "Confirm Password",
  "auth_cellphone": "Cell phone number",
  "auth_identity_cpf": "CPF",
  "auth_identity_cnpj": "CNPJ",
  "auth_cep": "Postal Code",
  "auth_corporate_name": "Company name",
  "auth_cnpj_first_name": "Name of legal representative",
  "auth_cnpj_last_name": "Last name of legal representative",
  "auth_identity_passport": "Passport",
  "auth_identity_national_document": "National document",
  "auth_document": "Document",
  "auth_nationality": "Nationality",
  "auth_birthdate": "Birthdate",
  "auth_identity_type_cpf": "I am an individual",
  "auth_identity_type_cnpj": "I am a legal entity",
  "auth_is_foreign": "I am a foreign",
  "auth_termsRead": "I have read and I agree with the ",
  "auth_terms": "User Policy",
  "auth_termsAnd": " and ",
  "auth_policy": "Privacy Policy",
  "auth_requiredCheckOfTermsAndPrivacyPolicy": "You must agree to the Terms and Privacy Policy to continue.",
  "auth_terms_close": "close",
  "auth_terms_loading": "Loading...",
  "auth_signup": "Signup",
  "auth_recoverPassword": "Recover password",
  "auth_backToLogin": "Back to Login",
  "auth_code": "Code",
  "auth_resetPassword": "Reset Password",
  "auth_goBackButton": "Go back",
  "auth_loginSubtitle": "We only use essential data to generate the consumption voucher",
  "auth_passwordResetSubtitle": "Enter the email registered on the platform to recover the password",
  "auth_validCodeSubtitle": "Enter the 6-digit code that was sent to",
  "auth_continue": "Continue",
  "auth_didNotGetTheEmail": "Did not get the email?",
  "auth_clickHere": "Click Here",
  "auth_passwordRecoverySubtitle": "Enter your new password below to complete the password reset process",
  "auth_redefinePassword": "Redefine password",
  "auth_messagePasswordModifiedSuccessFully": "Your password has been changed successfully!",
  "auth_resendEmailInfo": "The code will be resent to the following email:",
  "auth_fixEmail": "Fix email",
  "auth_messageAccountCreatedSuccessFully": "Your account has been created successfully!",
  "auth_continueShopping": "Continue shopping",
  "auth_emailUniquenessError_title": "Email already registered",
  "auth_emailUniquenessError_message": "We have identified that you have already registered with an establishment that uses Planne's e-commerce technology, so please proceed with creating a new password to perform a simplified login.<br></br><br></br>Your data is safe and is only shared with companies authorized by you.",
  "auth_emailUniquenessError_action": "Create new password",
  "auth_zipCode_max_length_error": "The postal code must have 8 digits",

  "auth_verify_phone_form_title": "Enter access key",
  "auth_verify_phone_form_subtitle": "Enter the code sent by SMS to the phone:",
  "auth_verify_phone_form_code": "Code",
  "auth_verify_phone_form_did_not_receive": "Didn't receive the sms?",
  "auth_verify_phone_form_resend": "Resend",
  "auth_verify_phone_form_submit": "Continue",
  "auth_verify_phone_form_back": "Back",
  "auth_verify_phone_form_code_expires_in": "You can request a new code at",
  "auth_invalid_verification_code": "The code must be 6 characters long",

  "checkout_confirmingYourPurchase": "Confirming your purchase...",
  "checkout_awaiting_confirmation_message": "We are checking availability. Please wait a moment before paying.",
  "checkout_awaiting_confirmation_unavailable_title": "No availability",
  "checkout_awaiting_confirmation_unavailable_description": "We could not confirm your booking. Please choose another date or time and try again.",
  "checkout_awaiting_confirmation_unavailable_action": "Choose another date or time",
  "checkout_pendingSales": "Pending Sales:",
  "checkout_saleNumber": "Sale #{saleNumber}",
  "checkout_item": "Item",
  "checkout_totalValue": "Total value:",
  "checkout_yourCartIsEmpty": "Your cart is empty!",
  "checkout_yourCartErrors": "The cart has the following errors:",
  "checkout_continueShopping": "Continue shopping",
  "checkout_finishSale": "Finish purchase",
  "checkout_placement": "Seats:",
  "checkout_resource_extra_value": "Extra for places:",
  "checkout_additionals": "Additionals",
  "checkout_invalidCoupon": "Invalid Voucher",
  "checkout_removeCoupon": "Remove Voucher",
  "checkout_couponCode": "Voucher code",
  "checkout_addCoupon": "Add discount voucher",
  "checkout_processingPayment": "Wait, the payment is being processed...",
  "checkout_expiredSale": "Expired sale",
  "checkout_makeYourPurchaseAgain": "Please, try to make your purchase again.",
  "checkout_percentDiscount": "% discount",
  "checkout_unavailablePaymentOptions": "Unavailable payment options",
  "checkout_unavailablePaymentMethod": "Unavailabe payment method.",
  "checkout_securityCode": "Security code",
  "checkout_validityMonth": "Validity month",
  "checkout_validityYear": "Validity year",
  "checkout_formInputPhonePlaceholder": "(99) 99999-9999",
  "checkout_formInputEmailPlaceholder": "your@bestemail.com",
  "checkout_formInputCpfPlaceholder": "000.000.000-00",
  "checkout_paymentIn": "Payment in",
  "checkout_addressTitle": "Address",
  "checkout_addressZipCode": "Postal Code (CEP)",
  "checkout_addressCountry": "Country",
  "checkout_addressState": "State",
  "checkout_addressStateHint": "Only the abbreviation. Ex.: RJ",
  "checkout_addressCity": "City",
  "checkout_addressDistrict": "Neighborhood",
  "checkout_addressStreet": "Street",
  "checkout_addressNumber": "Number",
  "checkout_addressComplement": "Complement",
  "checkout_nameAsInCard": "Name",
  "checkout_nameAsInCardHint": "As it is displayed on the card",
  "checkout_identityMessage": "Owner CPF number (if you leave this empty, the CPF/CNPJ {num} will be used)",
  "checkout_expiredTry": "Please try again, as your last try expired.",
  "checkout_fromValue": " From ",
  "checkout_toValue": " to ",
  "checkout_payWithPix": "Pay with Pix",
  "checkout_copiedCode": "Copied Code!",
  "checkout_finishPaymentWithPix": "Finalize your payment with PIX!",
  "checkout_pixUseCameraDescription": "You can use your cell phone camera to read the QR Code or copy the code and use it to pay at your bank app:",
  "checkout_verifyingPayment": "Verifying payment",
  "checkout_qrCodeWithPixCode": "QR Code with Pix code",
  "checkout_copyCode": "Copy Code",
  "checkout_completePurchaseStepsTitle": "To complete your purchase, follow the steps below",
  "checkout_ongoingPixDescription": "You still need to pay the Pix. You can use the option of payment with QR Code or copy and paste the code and finish the payment utilizing your preferred app or internet banking.",
  "checkout_remove": "Remove",
  "checkout_confirm": "Confirm the value exhibited, it needs to be the same to avoid the transaction cancellation, and also the receiver info (financial institution name: ",
  "checkout_nameOfReceiver": "name of receiving company: ",
  "checkout_atention": "Attention:",
  "checkout_warning1": "<strong>Do not pay using the Transfer function </strong> <span>, because the </span> <strong> transaction will not be completed and the return will not occur automatically </strong> <span>, being necessary that you contact our Service Center. </span>",
  "checkout_warning2": "<span>The payment confirmation period takes</span>  <strong> approximately 10 seconds</strong>    <span> but since it depends on the financial institution, so processing time may be extended.</span>",
  "checkout_warning3": "<strong>The QR Code is valid for 5 minutes</strong> <span>. If it is not paid within this period, you will need to</span> <strong> generate a new Pix code.</strong>",
  "checkout_units": "unit(s)",
  "checkout_method_softdescriptor": "On the card statement, this purchase appears on behalf of",
  "checkout_cardNumber": "Card number",
  "checkout_postalCode": "Postal Code",
  "checkout_buyerInfoCollectHeaderTitle": "Additional information",
  "checkout_buyerInfoCollectSubtitle": "We only use essential data to generate the consumption voucher",
  "checkout_buyerInfoCollectProceed": "Proceed",
  "checkout_buyerInfoCollectStepback": "Go back",
  "checkout_buyerInfoCollectFillWithSignupData": "Fill in the data provided in the registration",
  "checkout_tariff": "Tariff",
  "checkout_step_login": "Login",
  "checkout_step_signup": "Create Account",
  "checkout_step_personal": "Personal data",
  "checkout_step_payment": "Payment details",
  "checkout_step_payment_security_note": "All purchases made on this site are 100% secure, including your personal data and your card details.",
  "checkout_purchase_summary": "Purchase summary",
  "checkout_order_summary_title": "Order summary",
  "checkout_coupon_placeholder": "Discount coupon",
  "checkout_coupon_apply": "Apply",
  "checkout_coupon_affected_products": "Discount applied only to products:",
  "checkout_view_more": "View more",
  "checkout_view_product_details": "View product details",
  "checkout_sold_by": "Sold by",
  "checkout_tariffs_section": "Rates",
  "checkout_view_summary": "View summary",
  "checkout_hide_summary": "Hide summary",
  "checkout_discounts": "Discounts",
  "checkout_cart_summary_total": "Total: {total}",
  "checkout_cart_summary_products": "({count, plural, one {{count, number} product} other {{count, number} products}})",
  "checkout_title": "Checkout",
  "checkout_back_to_site": "Back to site",
  "checkout_back": "Back",
  "checkout_auth_identification_title": "Access your account",
  "checkout_auth_identification_subtitle": "Create or access your account",
  "checkout_auth_email_label": "Email",
  "checkout_auth_identification_cta": "Continue",
  "checkout_auth_or_divider": "OR",
  "checkout_auth_required_field": "Required field",
  "checkout_auth_invalid_email": "Invalid email",
  "checkout_auth_generic_error_title": "Unable to continue",
  "checkout_auth_generic_error": "We couldn't process your request right now. Please try again in a moment.",
  "checkout_auth_generic_error_retry": "Try again",
  "checkout_auth_login_title": "Access your account",
  "checkout_auth_login_existing_account_subtitle": "This email is linked to an account on our marketplaces. Enter your password to continue or, if you prefer, get a code by email to continue without a password.",
  "checkout_auth_login_password_subtitle": "Enter your email and password to continue or, if you prefer, get a code by email to continue without a password.",
  "checkout_auth_login_otp_subtitle": "We sent a 6-digit code to <strong>{email}</strong>, enter it below to continue.",
  "checkout_auth_password_label": "Password",
  "checkout_auth_show_password": "Show password",
  "checkout_auth_hide_password": "Hide password",
  "checkout_auth_forgot_password_prefix": "Forgot your password?",
  "checkout_auth_forgot_password_link": "Click here to recover",
  "checkout_auth_continue_cta": "Continue",
  "checkout_auth_continue_purchase_cta": "Continue purchase",
  "checkout_auth_login_with_code_cta": "Sign in with code",
  "checkout_auth_login_with_password_cta": "Sign in with password",
  "checkout_auth_otp_label": "Enter the code sent",
  "checkout_auth_otp_helper": "We sent a code to your email",
  "checkout_auth_otp_resend_countdown": "Resend code in {seconds}s",
  "checkout_auth_otp_resend_cta": "Resend code",
  "checkout_auth_otp_sending": "Sending code...",
  "checkout_auth_signup_link": "First time shopping? Sign up",
  "checkout_auth_signup_title": "Create your account",
  "checkout_auth_signup_subtitle": "Fill in your details to continue your purchase.",
  "checkout_auth_signup_identity_type_label": "Account type",
  "checkout_auth_signup_person_title": "I'm an individual",
  "checkout_auth_signup_person_subtitle": "I use my personal ID",
  "checkout_auth_signup_company_title": "I'm a business",
  "checkout_auth_signup_company_subtitle": "I use my company ID",
  "checkout_auth_signup_first_name_label": "First name",
  "checkout_auth_signup_last_name_label": "Last name",
  "checkout_auth_signup_legal_first_name_label": "Legal representative first name",
  "checkout_auth_signup_legal_last_name_label": "Legal representative last name",
  "checkout_auth_signup_corporate_name_label": "Company name",
  "checkout_auth_signup_cpf_label": "CPF",
  "checkout_auth_signup_cnpj_label": "CNPJ",
  "checkout_auth_signup_phone_label": "Mobile phone",
  "checkout_auth_signup_legal_phone_label": "Legal representative mobile phone",
  "checkout_auth_signup_foreign_checkbox": "I am a foreigner",
  "checkout_auth_signup_nationality_label": "Nationality",
  "checkout_auth_signup_foreign_document_label": "Document",
  "checkout_auth_signup_foreign_document_type_label": "Document type",
  "checkout_auth_signup_foreign_document_identity": "National ID",
  "checkout_auth_signup_foreign_document_passport": "Passport",
  "checkout_auth_signup_zip_code_label": "ZIP code",
  "checkout_auth_signup_postal_code_label": "Postal code (Optional)",
  "checkout_auth_signup_postal_code_hint": "Leave blank if your country does not use a postal code.",
  "checkout_auth_signup_zip_code_help_link_label": "I don't know my ZIP code",
  "checkout_auth_signup_zip_code_help_title": "Don't know your ZIP code?",
  "checkout_auth_signup_zip_code_help_intro": "We use your ZIP code to verify your details more securely at checkout.",
  "checkout_auth_signup_zip_code_help_tip_before": "Check a recent utility bill or mail, or look it up on the",
  "checkout_auth_signup_zip_code_help_link": "Correios website",
  "checkout_auth_signup_zip_code_help_tip_after": ".",
  "checkout_auth_signup_zip_code_help_close": "Close",
  "checkout_auth_signup_state_label": "State",
  "checkout_auth_signup_city_label": "City",
  "checkout_auth_signup_district_label": "Neighborhood",
  "checkout_auth_signup_street_label": "Street",
  "checkout_auth_signup_number_label": "Number",
  "checkout_auth_signup_complement_label": "Complement",
  "checkout_auth_signup_password_confirmation_label": "Confirm password",
  "checkout_auth_signup_password_hint": "At least 8 characters, with one uppercase letter, one lowercase letter and one number",
  "checkout_auth_signup_password_confirmation_hint": "Repeat the password",
  "checkout_auth_signup_terms_prefix": "I have read and agree to the",
  "checkout_auth_signup_terms_of_use": "Terms of use",
  "checkout_auth_signup_terms_connector": "and the",
  "checkout_auth_signup_privacy_policy": "Privacy policy",
  "checkout_auth_signup_secure_purchase": "100% secure purchase",
  "checkout_auth_signup_confirm_cta": "Confirm",
  "checkout_auth_signup_email_in_use_title": "Email already registered",
  "checkout_auth_signup_email_in_use_message": "An account with this email already exists. Log in or recover your password to continue.",
  "checkout_auth_signup_email_in_use_login": "Log in",
  "checkout_auth_signup_email_in_use_recover": "Create password",
  "checkout_auth_signup_email_not_found_title": "We couldn't confirm this email",
  "checkout_auth_signup_email_not_found_message": "Check that it is spelled correctly or use another address to create your account.",
  "checkout_auth_signup_invalid_cpf": "Invalid CPF",
  "checkout_auth_signup_invalid_cnpj": "Invalid CNPJ",
  "checkout_auth_signup_invalid_zip_code": "ZIP code must have 8 digits",
  "checkout_auth_signup_invalid_phone": "Enter a valid mobile phone number",
  "checkout_auth_signup_weak_password": "Password must have at least 8 characters, with one uppercase letter, one lowercase letter and one number",
  "checkout_auth_signup_password_mismatch": "Passwords do not match",
  "checkout_auth_signup_terms_required": "You must accept the terms to continue",
  "checkout_auth_signup_recaptcha_required": "Confirm you are not a robot",
  "checkout_auth_signup_foreign_cnpj_conflict": "Company signup is not available for foreign buyers",
  "auth_login_submit_cta": "Log in",
  "auth_login_password_subtitle": "Enter your password to access your account.",
  "auth_login_signup_link": "Don't have an account? Sign up",
  "checkout_auth_signup_page_title": "Create your account",
  "checkout_auth_reset_password_page_title": "Password reset",
  "checkout_auth_recovery_title": "Password recovery",
  "checkout_auth_recovery_email_subtitle": "Enter the registered email and we will send a 6-digit code to verify your identity.",
  "checkout_auth_recovery_otp_subtitle": "We sent a 6-digit code to <strong>{email}</strong>. Enter it below to continue with password recovery.",
  "checkout_auth_recovery_new_password_title": "Reset password",
  "checkout_auth_new_password_label": "New password",
  "checkout_auth_confirm_password_label": "Confirm password",
  "checkout_auth_password_min_length_helper": "Your password must contain at least 8 characters",
  "checkout_auth_password_repeat_helper": "Repeat the password",
  "checkout_auth_reset_password_cta": "Reset password",
  "checkout_auth_back_cta": "Back",
  "checkout_auth_did_not_receive_email": "Did not receive the email?",
  "checkout_auth_resend_email_link": "Click here to resend",
  "checkout_auth_otp_code_label": "Enter the code",
  "checkout_auth_otp_code_invalid": "Incorrect code. Check the characters and try again.",
  "checkout_auth_email_placeholder": "Enter your email",
  "checkout_auth_password_mismatch": "Passwords must match",
  "checkout_auth_password_strength": "Password must contain at least 8 characters, including uppercase, lowercase letters and numbers",
  "checkout_pix_proceed_description": "Click continue to generate the unique payment QR Code and proceed with your purchase.",
  "checkout_continue_pix": "Continue",
  "checkout_card_owner_cpf_cnpj": "CPF or CNPJ of Card Holder",
  "checkout_valid_date": "Expiration date (MM/YY)",
  "checkout_complete_purchase": "Complete purchase",
  "checkout_disapproved_warning": "Warning!",
  "checkout_disapproved_intro": "Disapproved purchase",
  "checkout_disapproved_try_again": "Try again",
  "checkout_purchase_summary_day": "Day",
  "checkout_purchase_summary_without_date": "No Scheduling",
  "checkout_payment_successful": "Payment made successfully",
  "checkout_payment_successful_redirect": "View Purchase",
  "checkout_payment_anti_fraud_error": "Check if the data is correct, or use another payment method.",
  "checkout_payment_transaction_error": "Check if the details are correct, or contact the card-issuing bank.",
  "checkout_payment_generic_transaction_error": "There was an error processing your transaction. Please wait a few moments and try again.",
  "checkout_payment_unauthorized_error": "Session expired. Please log in and try again.",
  "checkout_payment_discount_chip": "{percentage}% off",
  "checkout_payment_installments_chip": "Up to {count}x interest-free",
  "checkout_payment_card_number": "Card number",
  "checkout_payment_card_holder": "Cardholder name",
  "checkout_payment_card_holder_identity": "Cardholder CPF or CNPJ",
  "checkout_payment_card_zip_code": "Zip code",
  "checkout_payment_card_postal_code": "Postal code",
  "checkout_payment_card_security_code": "Security code (CVV)",
  "checkout_payment_card_installments": "Number of installments",
  "checkout_secure_purchase": "100% secure purchase",
  "checkout_additional_info_invalid_cpf": "Invalid CPF",
  "checkout_additional_info_invalid_phone": "Invalid phone number",
  "checkout_additional_info_invalid_date": "Invalid date",
  "checkout_additional_info_title": "Fill in important information about your booking",
  "checkout_additional_info_subtitle": "We only use essential data to generate your voucher",
  "checkout_additional_info_fill": "Fill in information",
  "checkout_additional_info_edit": "Edit",
  "checkout_additional_info_review": "Review",
  "checkout_additional_info_filled": "Filled in",
  "checkout_additional_info_not_filled": "Not filled in",
  "checkout_additional_info_partially_filled": "{filled} of {total} filled in",
  "checkout_additional_info_needs_review": "Needs review",
  "checkout_additional_info_continue": "Continue",
  "checkout_additional_info_next": "Next",
  "checkout_additional_info_done": "Done",
  "checkout_additional_info_save": "Save",
  "checkout_additional_info_cancel": "Cancel",
  "checkout_additional_info_error_alert": "Review the highlighted information",
  "checkout_additional_info_progress": "{filled}/{total}",
  "checkout_payment_card_submit": "Complete purchase",
  "checkout_payment_card_validity_must_be_valid": "Expiration must use the MM/YY format",
  "checkout_payment_card_foreign_alert_title": "International purchases",
  "checkout_payment_card_foreign_alert_description": "Your bank may block international purchases. Enable “Travel Notice” or “International Usage” in your bank’s app. Your bank may also ask for a confirmation to authorize the purchase.",
  "checkout_payment_pix_step_generate": "Click <strong>Generate Pix code</strong> to continue with your purchase",
  "checkout_payment_pix_step_confirm": "Check the details and pay through your bank app",
  "checkout_payment_pix_secure_purchase": "100% secure purchase",
  "checkout_payment_pix_generate_button": "Generate Pix code",
  "checkout_payment_pix_change_method": "Change payment method",
  "checkout_payment_pix_change_method_compact": "Switch payment method",
  "checkout_payment_pix_title": "Pay with Pix",
  "checkout_payment_pix_description": "You can use your phone camera to read the QR code, or copy the code and pay in your bank app.",
  "checkout_payment_pix_time_remaining": "Time left to pay:",
  "checkout_payment_pix_copy_button": "Copy code",
  "checkout_payment_pix_copied_tooltip": "Pix code copied",
  "checkout_payment_pix_how_to_title": "How to pay with Pix:",
  "checkout_payment_pix_how_to_1": "Open your preferred bank app or website.",
  "checkout_payment_pix_how_to_2": "Choose “pay with Pix Copy and Paste” or QR code.",
  "checkout_payment_pix_how_to_3": "Paste the code or scan the QR code;",
  "checkout_payment_pix_how_to_4": "Wait a few seconds. Your order is confirmed as soon as the payment goes through",
  "checkout_payment_pix_expired_title": "The Pix code has expired",
  "checkout_payment_pix_expired_description": "If you have already paid, your order can take up to 5 minutes to be confirmed",
  "checkout_payment_pix_expired_retry": "Try again",
  "checkout_payment_pix_receiver_disclaimer": "When you pay the Pix, the institution will show up as “<strong>{institution}</strong>”",
  "checkout_payment_account_title": "Account",
  "checkout_payment_account_edit": "Edit",
  "checkout_payment_step_title": "Payment",
  "checkout_payment_step_subtitle": "Choose a payment option:",
  "checkout_phone_verification_alert_message": "You need to confirm your phone number",
  "checkout_phone_verification_alert_button": "Confirm",
  "checkout_sale_change_previous_reservation": "Current reservation",
  "checkout_sale_change_new_reservation": "New reservation",

  "checkout_confirmed_greeting": "Thank you, {name}!",
  "checkout_confirmed_title": "Payment confirmed",
  "checkout_confirmed_description": "You can download your vouchers now. They were also sent by email and are available in your account whenever you need them",
  "checkout_confirmed_additionals": "Add-ons",
  "checkout_confirmed_additionals_overflow": "+{count}",
  "checkout_confirmed_additionals_show_more": "See more",
  "checkout_confirmed_reschedule": "Reschedule",
  "checkout_confirmed_reschedule_available": "Reschedules available: <span>{count}</span>",
  "checkout_confirmed_reschedule_deadline": "Deadline to request a reschedule: <span>{deadline}</span>",
  "checkout_confirmed_reschedule_deadline_antecedence": "Up to {antecedence} before the booking",
  "checkout_confirmed_reschedule_expired": "The deadline to reschedule has expired",
  "checkout_confirmed_reschedule_unavailable": "Promotional bookings cannot be rescheduled. Contact the venue for more information.",
  "checkout_confirmed_reschedule_package_tooltip": "Package bookings are rescheduled together. Contact the venue.",
  "checkout_confirmed_vouchers_count": "Vouchers: {count}",
  "checkout_confirmed_vouchers_view_all": "See all",
  "checkout_confirmed_vouchers_pending_tooltip": "The vouchers are still being issued. Try again in a few moments.",
  "checkout_confirmed_download_all_vouchers": "Download all vouchers",

  "checkout_order_details_title": "Order details",
  "checkout_order_details_email": "Email",
  "checkout_order_details_account_type": "Account type",
  "checkout_order_details_account_type_individual": "Individual",
  "checkout_order_details_account_type_company": "Company",
  "checkout_order_details_first_name": "First name",
  "checkout_order_details_last_name": "Last name",
  "checkout_order_details_representative_first_name": "Legal representative first name",
  "checkout_order_details_representative_last_name": "Legal representative last name",
  "checkout_order_details_corporate_name": "Company name",
  "checkout_order_details_country": "Country of origin",
  "checkout_order_details_cpf": "CPF",
  "checkout_order_details_cnpj": "CNPJ",
  "checkout_order_details_national_document": "National document",
  "checkout_order_details_passport": "Passport",
  "checkout_order_details_phone": "Mobile",
  "checkout_order_details_payment_method": "Payment method",
  "checkout_order_details_installments": "Number of installments",
  "checkout_order_details_installments_value": "{count}x of {amount}",
  "checkout_order_details_zip_code": "Zip code",

  "checkout_payment_method_credit_card": "Credit card",
  "checkout_payment_method_debit_card": "Debit card",
  "checkout_payment_method_pix": "Pix",
  "checkout_payment_method_post_paid": "Invoiced",

  "checkout_vouchers_modal_code": "Code",
  "checkout_vouchers_modal_password": "Password",
  "checkout_vouchers_modal_status": "Status",
  "checkout_vouchers_modal_status_open": "Not used",
  "checkout_vouchers_modal_status_consumed": "Used",
  "checkout_vouchers_modal_status_revoked": "Canceled",
  "checkout_vouchers_modal_status_pending": "Awaiting confirmation",
  "checkout_vouchers_modal_download": "Download voucher",
  "checkout_vouchers_modal_tariff_quantity": "{count}x {name}",

  "checkout_payment_gateway_mismatch_error_title": "Unable to proceed with payment",
  "checkout_payment_gateway_mismatch_error_description": "There was an error in the financial information of the person responsible for the sale. To proceed with your purchase, contact our support.",
  "checkout_payment_gateway_mismatch_error_ok": "OK",
  "checkout_payment_gateway_blocked_buyer_error_title": "Unable to process payment",
  "checkout_payment_gateway_blocked_buyer_error_helper_text": "You have exceeded the maximum attempt limit. To continue with your purchase, use another payment method",

  "checkout_error_foreignCustomerNotAllowed": "This application does not allow foreign purchases. Please contact the establishment for more information.",
  "checkout_foreign_buyer_alert_badge": "IMPORTANT",
  "checkout_foreign_buyer_alert_title": "International purchases",
  "checkout_foreign_buyer_alert_description": "Your bank may block international purchases. Enable <strong>“Travel Notice”</strong> or <strong>“International Usage”</strong> in your bank's app. The bank may also ask for <strong>a confirmation to authorize the purchase.</strong>",

  "timeout_error_title": "Unable to communicate with the server",
  "timeout_error_description": "Ops, we had a problem communicating with the server. Please wait a few moments and try again.",
  "timeout_error_ok": "OK",

  "checkout_pix_payment_insufficient_amount_title": "Insufficient amount for payment via Pix",
  "checkout_pix_payment_insufficient_amount_description": "Add more products to the cart or use another payment method",

  "adder_dataSelected": "Selected date: ",
  "adder_buy": "Buy Now",
  "adder_goBack": "go back",
  "adder_quantity": "Quantity",
  "adder_hour": "Select an hour",
  "adder_unavailableQuantity": "Unavailable quantity",
  "adder_outOfStock": "Sold off",
  "adder_additionals": "Additionals",
  "adder_additionals_perPerson": "p/ tariff",
  "adder_additionals_remain": "Remaining",
  "adder_additionals_soldOff": "Sold off",
  "adder_productAddedToCart": "Product added to the cart!",
  "adder_productNotAddedToCart": "Failed to add product to cart",
  "adder_seeCart": "See my cart",
  "adder_perPerson": "per person",
  "adder_singleErrorLabel": "The quantity selected for this tariff is not available",
  "adder_multipleErrorLabel": "The quantity of the selected tariffs has exceeded the limit for this date",
  "adder_dependent_tariff": "Dependent",
  "adder_dependent_tariff_selection_error": "Please select at least one tariff that is not dependent to proceed",
  "adder_hours_unavailable_error": "Unavailable hour for selected tariffs quantities",
  "adder_additionals_custom_type_quantity_placeholder": "Enter the desired quantity",
  "adder_additionals_custom_type_quantity_error": "The quantity must be greater than zero",
  "adder_additionals_custom_type_max_quantity_error": "The maximum quantity allowed is {maxQuantity}",
  "adder_seats_missing_tariffs_unavailable_error": "We did not find available seats for these selected rates and times. To proceed, add more {missing} rate(s) to your selection or try another available time.",
  "adder_seats_unavailable_error": "No available places were found for the selected rates and time. To proceed, choose another available date/time.",
  "adder_error_generic": "We could not add this selection to the cart. Please review the details and try again.",
  "adder_error_tariff_quantity_limit": "The selected quantity is above the limit allowed for this rate. Reduce the quantity to continue.",
  "adder_error_tariff_unavailable": "There is no availability for the selected quantity. Reduce the quantity or pick another date/time.",
  "adder_error_additional_unavailable": "There is no availability for the selected add-ons. Review your selection to continue.",
  "adder_error_schedule_unavailable": "The selected date or time is no longer available. Pick another option to continue.",
  "adder_error_seats_unavailable": "There are not enough seats for the selected quantity. Reduce the quantity or pick another time.",
  "adder_error_seats_missing_capacity": "This time is {missing} seat(s) short for the selected quantity. Reduce the quantity or pick another time.",
  "adder_error_product_unavailable": "This product is not available for purchase right now.",
  "adder_tariff_verification_field_required": "This field is required",
  "adder_tariff_verification_validation_error": "Invalid verification data",
  "adder_tariff_verification_document_validation_error": "The document number provided is not valid or does not meet the criteria required for this tariff.",
  "adder_tariff_verification_date_validation_error": "The birth date provided does not meet the criteria required for this tariff.",
  "sale_totalValue": "Total value: ",
  "sale_termExpired": "The payment time limit for this order has expired.",
  "sale_printAll": "Print all",
  "sale_print": "Print",
  "sale_productColumn": "Product",
  "sale_dateColumn": "Date",
  "sale_hourColumn": "Hour",
  "sale_quantityColumn": "Qty",
  "sale_codeColumn": "Voucher",
  "sale_passwordColumn": "Password",
  "sale_stateColumn": "State",
  "sale_noAvailableReservation": "No booking available!",
  "sale_reschedule": "Reschedule",
  "sale_unavailableReschedule": "Reschedule is unavailable!",
  "sale_awaitingDate": "Waiting for a date...",
  "sale_consumed": "Consumed",
  "sale_open": "Open",
  "sale_goBack": "Go back",

  "seatMap_selectOneTime": "Select only one schedule hour",
  "seatMap_tariffUnits": "Unit(s)",
  "seatMap_pendingAllocationQuantity": "Allocated amount:",
  "seatMap_pendingTariffAllocation": "Some tariffs have not yet been allocated",
  "seatMap_resourceMinValue": "Place value",
  "seatMap_filledCapacity": "places",
  "seatMap_resourceSubAllocationNotice": "The amount of tariffs allocated to the table is less than allowed, please select another table.",
  "seatMap_resourceReservationPrice": "Extra for places",
  "seatMap_totalPrice": "Total",
  "seatMap_canvas_subtitles": "Subtitles",
  "seatMap_tariff_price_cents": "Tariff value",
  "seatMap_selectSeat": "Select the seat",

  "awaiting_confirmation": "Awaiting confirmation",
  "created": "Open",
  "pending": "Pending",
  "expired": "Expired",
  "confirmed": "Confirmed",
  "payment_complete": "Confirmed payment",
  "payment_voided": "Reversed payment",
  "payment_chargeback": "Chargeback",
  "payment_charged_back": "Chargeback",
  "payment_denied": "Denied",
  "canceled": "Canceled",
  "available": "Available",
  "selected": "Selected",
  "blocked": "Blocked",
  "unavailable": "Unavailable",
  "no_option_found": "No option found",

  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",

  "cart_item_remove_error": "Error removing item from cart. Please try again or contact the merchant.",
  "cart_package_error": "Any item has been changed or removed by the seller, please remove the item from the cart",
  "cart_package_details": "Products details",
  "cart_item_price_summary_previous": "Previous price",
  "cart_iconLabel": "Your cart has {quantity} items",
  "cart_loading": "Loading shopping cart",
  "cart_header": "Shopping Cart",
  "cart_totalLabel": "Total",
  "cart_subtotal": "Subtotal",
  "cart_final_value": "Final value",
  "cart_coupon_text": "Coupon",
  "cart_itemErrorWarning": "This item has been changed by the provider. Remove it from the cart.",
  "discount_fallback_warning_message": "The discount for this product has been changed by the seller",
  "cart_value": "Value",
  "cart_checkout": "Checkout",
  "cart_discount": "Discount",
  "cart_apply": "Apply",
  "cart_cancel": "Remove",
  "cart_openAreaApplyVoucher": "Open area to apply the voucher code",
  "cart_closeAreaApplyVoucher": "Close voucher code area",
  "cart_voucherTitle": "Discount Voucher",
  "cart_selectedDate": "Date",
  "cart_selectedLanguage": "Language",
  "cart_selectedTariff": "Tariff",
  "cart_selectedResources": "Selected Seat",
  "cart_additionals": "Additionals",
  "cart_itens": "Items",
  "cart_backToHome": "Back to landing page",
  "cart_pleaseWait": "Please wait!",
  "cart_yourCartIsEmpty": "Your cart is empty",
  "cart_addProductInstruction": "Add a product to cart",
  "cart_closeCart": "Close cart modal",
  "cart_quantity": "Quantity",
  "cart_remove_discount_button": "Remove",
  "cart_discount_coupon_button_title": "Add discount coupon",
  "cart_discount_coupon_submit_button": "ADD",
  "cart_discount_coupon_applied_succefully": "Discount coupon applied",
  "cart_discount_coupon_product": "Product only:",
  "cart_discount_coupon_product_list": "Only for products:",
  "cart_package_date": "Date:",
  "cart_package_tariff": "Tariffs:",
  "cart_package_previous_price": "Previous price",
  "cart_package_discount": "Discount",
  "cart_package_total": "Total",
  "cart_package_product_details": "Product details",

  "adder_step_calendar": "Select a date",
  "adder_step_tariff": "Select a tariff",
  "adder_step_seat_map": "Select a seat",
  "adder_selected_date": "Date Selected",
  "adder_step_additional": "Select the additionals",
  "adder_step_finish": "Add to cart",
  "adder_step_package_quantity": "Select a quantity",
  "adder_priceAccordingToSchedule": "according to time",
  "adder_day": "Day",
  "adder_night": "Night",
  "adder_price_per_unit": "Price per item",
  "adder_goBackFooter": "Go back",
  "adder_goForwardsFooter": "Continue",
  "adder_purchaseButton": "Buy",
  "adder_serviceFee": "Service fees may be charged",
  "adder_selectedTariff": "Selected Tariff",
  "adder_selectedResources": "Selected Seat",
  "adder_legend_current": "Current Day",
  "adder_legend_available": "Available",
  "adder_legend_unavailable": "Unavailable",
  "adder_legend_suggested_prices": "Prices subject to change",
  "adder_legend_suggested_prices_tooltip": "The displayed price may vary depending on the time or fare chosen",
  "adder_legend_busy": "Peak Season",
  "adder_unavailableTariffNotice": "Sold Off",
  "adder_tryAgain": "Try Again",
  "adder_price_from": "From",
  "adder_price_to": "To",
  "adder_updating_price": "Updating…",
  "adder_price_update_failed": "Couldn't update the price. Showing the last value.",

  "terms_of_use": "Terms of Use",
  "privacy_policy": "Privacy Policy",

  "direct_link_sale_title": "Cart",
  "direct_link_payment_title": "Payment",
  "direct_link_pay_button": "Pay",
  "direct_link_finished_payment_message": "Completed payment",
  "direct_link_finished_sale_message": "Completed purchase",
  "direct_link_cancelled_message": "Cancelled link",
  "direct_link_checkout_error_couponHasUsesLeft": "The coupon used in the cart no longer has available uses. Please contact the establishment for more information.",
  "direct_link_checkout_error_resourceMustBeAvailable": "Place not available",
  "direct_link_checkout_error_tariffOccupationMustBeRespected": "There are no more spots available for this rate at the selected time",

  "coupon_code": "Invalid coupon!",
  "coupon_expires_at": "Coupon expired",
  "coupon_max_use": "Coupon has exceeded the maximum number of uses",
  "coupon_max_use_per_user": "Oops! You have already used this coupon the maximum number of times allowed",
  "coupon_invalid_for_these_products": "Coupon not applicable to selected products.",

  "open_purchase_title": "Finalize the payment",
  "open_purchase_description": "You have an unfinished purchase, would you like to continue?",
  "open_purchase_button_text": "Yes",

  "direct_link_required_field": "Required field",

  "customer_form_invalid_document": "Invalid document",
  "customer_form_email_does_not_match": "E-mail does not match",
  "customer_form_invalid_birthdate": "Invalid birthdate",

  "direct_link_invalid_message": "Invalid link",
  "direct_link_expired_message": "Link expired",

  "direct_link_auth_step_title": "Contact details",
  "direct_link_payment_step_title": "Payment",
  "direct_link_summary_title_payment": "Payment Summary",
  "direct_link_summary_title_sale": "Purchase summary",

  "direct_link_auth_message": "Your tickets will be sent to the email address provided. Please enter a valid email address",
  "direct_link_auth_email_label": "Email",
  "direct_link_auth_continue": "Continue",

  "direct_link_auth_login_title": "Login",
  "direct_link_auth_login_or": "Or",
  "direct_link_auth_login_with_otp": "Login with access key",
  "direct_link_auth_login_with_password": "Login with password",

  "direct_link_user_form_email_label": "Email",
  "direct_link_user_form_email_confirmation_label": "Confirm email",
  "direct_link_user_form_name_label": "Name",
  "direct_link_user_form_representative_legal_name_label": "Name of legal representative",
  "direct_link_user_form_lastname_label": "Lastname",
  "direct_link_user_form_representative_legal_lastname_label": "Lastname of legal representative",
  "direct_link_user_form_phone_label": "Phone",
  "direct_link_user_form_cpf_identity_label": "CPF",
  "direct_link_user_form_cnpj_identity_label": "CNPJ",
  "direct_link_user_form_identity_label": "CPF/CNPJ",
  "direct_link_user_form_birthday_label": "Birthdate",
  "direct_link_user_form_zip_code_label": "Postal code",
  "direct_link_user_form_corporate_name_label": "Company name",
  "direct_link_user_form_terms_message": "By proceeding with the purchase you will be agreeing to the ",
  "direct_link_user_form_terms_message_use_terms": "Terms",
  "direct_link_user_form_terms_message_and": " and ",
  "direct_link_user_form_terms_message_privacy_policy": "Privacy Policies",
  "direct_link_user_form_continue": "Continue",
  "direct_link_user_form_identity_type_cpf": "I am an individual",
  "direct_link_user_form_identity_type_cnpj": "I am a legal entity",
  "direct_link_user_form_corporate_name": "Company name",
  "direct_link_user_form_is_foreign": "I am a foreign",
  "direct_link_user_form_nationality": "Nationality",
  "direct_link_user_form_document": "Document",
  "direct_link_user_form_identity_national_document": "National document",
  "direct_link_user_form_identity_passport": "Passport",

  "direct_link_password_form_title": "Enter password to log in",
  "direct_link_password_form_password_label": "Password",
  "direct_link_password_form_login": "Login",
  "direct_link_password_form_forgot_password": "Forgot your password?",

  "direct_link_forgot_password_modal_title": "Reset password",

  "direct_link_reset_password_form_title": "Enter the code we sent you by email",
  "direct_link_reset_password_code_label": "Access code",
  "direct_link_reset_password_code_expires": "Code expires in",
  "direct_link_reset_password_sending_code": "Sending code...",
  "direct_link_reset_password_resend_code": "Resend code",
  "direct_link_reset_password_cancel": "Cancel",
  "direct_link_reset_password_confirm": "Confirm",

  "direct_link_change_password_form_title": "Enter new password",
  "direct_link_change_password_form_password_label": "New password",
  "direct_link_change_password_form_password_confirmation_label": "Confirm new password",
  "direct_link_change_password_form_cancel": "Cancel",
  "direct_link_change_password_form_confirm": "Confirm",
  "direct_link_change_password_password_match": "Passwords do not match",

  "direct_link_auth_login_otp_form_title": "Enter the code we sent you by email",
  "direct_link_auth_login_otp_form_code_label": "Access code",
  "direct_link_auth_login_otp_form_login": "Login",
  "direct_link_auth_login_otp_form_code_expires": "Code expires in",
  "direct_link_auth_login_otp_form_sending_code": "Sending code...",
  "direct_link_auth_login_otp_form_resend_code": "Resend code",

  "direct_link_summary_date_and_time": "Date and time",
  "direct_link_summary_subtotal": "Subtotal",
  "direct_link_summary_coupon": "Coupon",
  "direct_link_summary_discount": "Discount",
  "direct_link_summary_total": "Total",

  "direct_link_validate_phone_message": "You need to validate your phone",
  "direct_link_validate_phone_validate": "Validate",
  "direct_link_validate_phone_modal_title": "Inform access key",

  "direct_link_phone_verification_form_title": "Enter the code we sent you via SMS to your phone:",
  "direct_link_phone_verification_form_code_label": "Access code",
  "direct_link_phone_verification_form_code_expires": "Code expires in",
  "direct_link_phone_verification_form_sending_code": "Sending code...",
  "direct_link_phone_verification_form_resend_code": "Resend code",
  "direct_link_phone_verification_form_submit": "Continue",

  "direct_link_card_form_submit": "Checkout",
  "direct_link_card_form_identity_must_be_valid": "The number must be valid",
  "direct_link_card_form_postal_code_must_be_valid": "The postal code must be valid",
  "direct_link_card_form_postal_code_must_have_8_digits": "The postal code must have 8 digits",
  "direct_link_card_form_card_number_must_be_valid": "Card must be valid",
  "direct_link_card_form_card_brand_not_accepted": "The card brand is not accepted",
  "direct_link_card_form_card_expired": "The card cannot be expired",
  "direct_link_card_form_validity_placeholder": "MM/YY",
  "direct_link_card_form_holder_helper": "As stated on the card",

  "direct_link_pix_form_step_1_title": "You will be paying with PIX",
  "direct_link_pix_form_step_1_description": "Payment confirmation takes just a few minutes. Use your bank's app to pay.",
  "direct_link_pix_form_step_1_pix_amount": "Amount in PIX:",
  "direct_link_pix_form_step_1_finish": "Checkout",

  "direct_link_pix_form_step_2_instruction": "Open your payment app and choose the option <strong>Read QR Code</strong>",
  "direct_link_pix_form_step_2_camera_instruction": "Point your phone's camera at the QR Code",
  "direct_link_pix_form_step_2_copy_code": "Copy code",
  "direct_link_pix_form_step_2_code_copied": "Copied!",
  "direct_link_pix_form_step_2_verifying_payment": "Verifying payment",

  "direct_link_pix_form_steps_step_1": "Complete the purchase by clicking \"Checkout\"",
  "direct_link_pix_form_steps_step_2": "Read the QR Code with your bank's app or copy the PIX key",
  "direct_link_pix_form_steps_step_3": "After payment confirmation, your reservation will be confirmed",

  "direct_link_payment_success_alert": "Payment made!",
  "direct_link_payment_success_message": "We are pleased to inform you that your payment has been successfully received.",
  "direct_link_payment_success_voucher_message": "For more details, download your Voucher.",
  "direct_link_payment_success_download_vouchers": "Download all vouchers",

  "direct_link_min_code_length": "The code must be at least 6 characters long",
  "direct_link_max_code_length": "The code must be at maximum 6 characters long",

  "direct_link_min_password_length": "The password must be at least 8 characters long",
  "direct_link_password_strength": "The password must contain at least 8 characters, with at least one uppercase letter, one lowercase letter and one number.",

  "direct_link_user_form_terms_modal_title": "Terms of Use",
  "direct_link_user_form_privacy_policy_modal_title": "Privacy Policies",

  "direct_link_zipCode_max_length_error": "The postal code must have 8 digits",

  "cashback_growth_modal_title": "Your purchase earned cashback!",
  "cashback_growth_modal_store_hint": "You can use in <strong>parks</strong>, <strong>restaurants</strong> and <strong>partner tours</strong>.",
  "cashback_growth_modal_deadline": "Redeem your cashback via WhatsApp. The time to use it starts when you redeem it.",
  "cashback_growth_redeem_whatsapp": "Redeem via WhatsApp",
  "cashback_growth_redeem_short": "Redeem",
  "cashback_growth_decline": "No cashback for now",
  "cashback_growth_card_with_name": "{name}, your purchase earned cashback to use in restaurants, tours and attractions in Serra Gaúcha. The time to use it starts when you redeem it.",
  "cashback_growth_card_without_name": "Your purchase earned cashback to use in restaurants, tours and attractions in Serra Gaúcha. The time to use it starts when you redeem it.",

  "partnership_banner_discount": "{value} discount!",
  "partnership_banner_message": "Buy now and get {value} off from {affiliateName}! The coupon <strong>{couponCode}</strong> will be automatically applied to your cart.",
  "partnership_banner_continue": "Continue",

  "recaptcha_validation_error": "Please, confirm that you are not a robot",

  "phone_verification_title": "Almost there!",
  "phone_verification_subtitle": "Enter the code sent via SMS to phone",
  "phone_verification_submit_button": "Enter",

  "invalid_value": "Invalid coupon!",
  "coupon_is_active": "Coupon not applicable for these dates.",
  "coupon_has_uses_left": "Coupon has exceeded the maximum usage limit.",
  "coupon_has_customer_uses_left": "Oops! You have already used this coupon the maximum allowed number of times.",
  "coupon_has_some_products": "Coupon not applicable to the selected products!",
  "coupon_purchase_min_amount_cents_not_reached": "Coupon's minimum value not reached. Add more items to the cart to proceed with the discount.",
  "coupon_has_some_valid_item": "Coupon not applicable to the selected products!",

  "product_package_adder_product_list_title": "Products",
  "product_package_adder_total": "Total",
  "product_package_adder_selection_step_calendar": "Choose a date for: ",
  "product_package_adder_selection_step_tariff": "Choose a tariff for: ",
  "product_package_adder_selection_step_seat_map": "Choose seats for: ",
  "product_package_adder_selection_step_additional": "Choose additional for: ",
  "product_package_adder_add_to_cart_button": "Add to cart",
  "product_package_adder_complete_selection_description": "All products in the {packageName} Combo with {productQuantity} activities have been configured",
  "product_package_cancel_modal_title": "Do you want to close the package?",
  "product_package_cancel_modal_description": "Closing the package configuration will remove all configured products.",
  "product_package_cancel_modal_action_no": "No",
  "product_package_cancel_modal_action_yes": "Yes",
  "product_package_error_while_load_package_data": "An error occurred while loading package data. Please contact the establishment.",
  "product_package_error_empty_package": "It appears that this package does not have any products available for sale. Please contact the establishment.",
  "product_package_error_has_inactive_product": "Ops! One of the products in this package is unavailable for sale. Please contact the establishment.",
  "product_package_error_while_load_package_products_data": "An error occurred while loading the package products. Please contact the establishment.",
  "product_package_single_booking_unavailable": "This package is unavailable for the selected options.",
  "product_package_single_booking_quantity_step_title": "Choose the tariff quantity for all products in the package",
  "product_package_single_booking_chosen_date": "Chosen date",
  "product_package_single_booking_additional_fees": "Additional fees may be charged",
  "product_package_adder_sold_by": "Sold by: {owner}",
  "checkout_bin_code_validation_error": "The credit card provided is not qualified for the acquisition of the selected tariffs. Use another card.",

  "tds_generic_error": "Error processing payment",
  "tds_transaction_failed": "Payment failed",
  "tds_transaction_denied": "Payment denied",
  "tds_invalid_transactable": "Invalid transaction",

  "currency_warning_message": "Values shown in other currencies are for reference only. The charge will be made in Brazilian Real (BRL).",

  "cart_serviceFee": "Service fee",
  "cart_serviceFee_tooltip": "The service fee is used for platform maintenance and operation.",

  "product_booking_add_to_cart": "Add to cart",
  "product_booking_date_placeholder": "Select a date",
  "product_booking_language_placeholder": "Select a language",
  "product_booking_attribute_placeholder": "Select the {attribute}",
  "product_booking_attribute_no_option_found": "No option found",
  "product_booking_attribute_loading": "Loading...",
  "product_booking_attribute_pickup_zone_label": "Pickup zone",
  "product_booking_tariff_placeholder": "Select a tariff",
  "product_booking_tariff_summary": "{count, plural, one {{count, number}x Tariff} other {{count, number}x Tariffs}}",
  "product_booking_additionals_summary": "{count, plural, one {{count, number}x Additional} other {{count, number}x Additionals}}",
  "product_booking_service_fee_note": "Service fees may apply",
  "product_booking_no_tariffs": "No tariffs available for this date",
  "product_booking_tariff_max_availability_reached": "Maximum available quantity for this product has been reached",
  "product_booking_trust_instant_title": "Instant confirmation",
  "product_booking_trust_instant_description": "Receive your voucher immediately by email.",
  "product_booking_trust_secure_title": "Secure payment",
  "product_booking_trust_secure_description": "Your data is protected.",
  "product_booking_price_in_up_to_installments": "Up to {count}x",
  "product_booking_price_interest_free": "Interest free",
  "product_booking_price_or_at_sight": "or {price} at sight",
  "product_booking_price_starting_from": "Starting from",
  "product_booking_price_at_sight_label": "At sight",
  "product_booking_price_at_sight_compact": "{price} at sight",
  "product_booking_total_label": "RESERVATION TOTAL",
  "product_booking_total_at_sight_suffix": "at sight",
  "product_booking_view_summary": "View summary",
  "product_booking_additionals": "Select additional (Optional)",
  "product_booking_quantity_minus": "Decrease quantity",
  "product_booking_quantity_plus": "Increase quantity",
  "product_booking_select_date_first": "Select a date first",
  "product_booking_select_language_first": "Select a language first",
  "product_booking_select_tariff_first": "Select a tariff first",
  "product_booking_select_time_first": "Select a time first",
  "product_booking_select_seat_map_first": "Complete seat selection first",
  "product_booking_select_additionals_first": "Complete required add-on fields first",
  "product_booking_select_attribute_first": "Select {attribute} first",
  "product_booking_trending_reservations": "{count, plural, one {{count, number} person booked} other {{count, number} people booked}} in the last 24hrs",
  "product_upsell_modal_title": "Added to cart!",
  "product_upsell_modal_description": "Take the opportunity to secure other amazing experiences recommended by our specialists.",
  "product_upsell_sold_by": "Sold by: {owner}",
  "product_upsell_price_prefix": "Starting from",
  "product_upsell_add_offer": "Add {product}",
  "product_upsell_remove_offer": "Remove {product}",
  "product_upsell_selected_count": "{count, plural, one {{count, number} selected item} other {{count, number} selected items}}",
  "product_upsell_no_thanks": "No, thanks",
  "product_upsell_continue": "Continue",
  "upsell_booking_cancel_title": "Discard upsell?",
  "upsell_booking_cancel_description": "If you close now, all additional products will be discarded and you will be redirected to the cart with only the main product.",
  "upsell_booking_cancel_action_no": "Continue",
  "upsell_booking_cancel_action_yes": "Discard",
  "upsell_booking_product_list_title": "Selected products",
  "upsell_booking_completed_description": "All products have been configured",
  "code_input_value_label": "Value {index} of {length}",

  "checkout_payment_error_declined_title": "We couldn't complete your purchase with this card",
  "checkout_payment_error_declined_body": "For your protection, this payment was declined by our security system. Please review your card details or try a different card.",
  "checkout_payment_error_declined_body_pix": "",
  "checkout_payment_error_issuer_title": "Payment not authorized by your bank",
  "checkout_payment_error_issuer_body": "Your card issuer declined the transaction. This may happen due to insufficient funds, incorrect card details, or a security restriction. Please review the information entered and check if your bank requires a confirmation to authorize this purchase. You can also try a different card.",
  "checkout_payment_error_issuer_body_pix": "",
  "checkout_payment_error_secondary_pix": "Pay with PIX",
  "checkout_payment_error_retry": "Try again",
  "checkout_payment_error_expired_title": "Your order has expired",
  "checkout_payment_error_expired_description": "The time to complete this payment has ended. To secure your products, simply select them again and finish your purchase.",
  "checkout_payment_error_expired_retry": "Try again"
}
